import { get, post, patch, upload } from '../../../api';

export async function validateAccount(payload) {
    try {
        const data = await post('/api/account/validate', payload);
        return data.exists;
    } catch (e) {
        console.warn(e);
    }
    return false;
}

export async function loadCompany(uid) {
    const data = await get(`/api/organizations/${uid}`);
    return data['data'][0];
}

export async function updateCompanyLicense(uid, data) {
    const { subscription_level, seats, name } = data;

    const results = await patch(`/api/organizations/${uid}`, {
        update: 'license',
        organization: {
            subscription_level,
            seats,
            name,
        },
    });
    const organization = results['data'];
    if (results.error) {
        return results;
    }
    return organization;
}

export async function updateCompany(uid, data, uploadLogo) {
    const {
        name,
        business_name,
        address1,
        address2,
        country,
        city,
        region,
        postal_code,
        license_type,
        subscription_level,
        seats,
    } = data;

    const results = await patch(`/api/organizations/${uid}`, {
        organization: {
            name,
            business_name,
            address1,
            address2,
            country,
            region,
            city,
            postal_code,
            license_type,
            subscription_level,
            seats,
        },
    });
    if (results.error) {
        return results;
    }
    const organization = results['data'];
    if (uploadLogo) {
        if (data.logoBlob) {
            await upload(
                `/api/organization/${uid}/upload_logo`,
                {},
                data.logoBlob
            );
        } else if (!data.logo) {
            await post(`/api/organization/${uid}/upload_logo`, {});
        }
    }
    return organization;
}

export async function createCompany(data) {
    const {
        address1,
        address2,
        country,
        city,
        region,
        postal_code,
        email,
        username,
        phone,
        name,
        type,
        last_name,
        first_name,
        business_name,
        license_type,
        subscription_level,
        seats,
        mapping,
        connector_uuid,
    } = data;
    const response = await post('/api/organizations', {
        organization: {
            type,
            name,
            business_name,
            phone,
            address1,
            address2,
            country,
            region,
            city,
            postal_code,
            license_type,
            subscription_level,
            seats,
        },
        account: {
            first_name,
            last_name,
            email,
            phone,
            username,
        },
        mapping,
        connector_uuid,
    });
    const organization = response['data'];
    if (data.logoBlob) {
        const url = `/api/organization/${organization}/upload_logo`;
        await upload(url, {}, data.logoBlob);
    }
    return organization;
}
